<template>
  <div class="ch-page">
    <div class="ch-header">
      <div>
        <h1 class="ch-title">Channels</h1>
        <p class="ch-sub">All your connected media.</p>
      </div>
    </div>

    <div class="ch-grid">
      <influencer-channel-card
        v-for="influencerChannel in filteredInfluencerChannels"
        :key="influencerChannel.uuid"
        :influencer-channel="influencerChannel"
        @input="onChannelUpdated"
      ></influencer-channel-card>

      <router-link :to="{ name: 'channel.create' }" class="ch-add-tile">
        <i class="fal fa-plus-circle"></i>
        <span>Add channel</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import InfluencerChannelCard from "../../cards/InfluencerChannelCard";
export default {
  components: {
    InfluencerChannelCard
  },
  data: () => ({
    influencerChannels: []
  }),
  methods: {
    ...mapActions("loading", ["setPageLoading"]),
    ...mapActions("influencer", ["getInfluencerChannels"]),
    ...mapMutations("influencer", { setChannels: "SET_CHANNELS" }),
  },
  computed: {
    ...mapState("core/auth", ["user"]),

    filteredInfluencerChannels() {
      return this.influencerChannels.filter(item => item.active);
    }
  },
  created() {
    // Display loading so list isn't empty
    this.setPageLoading(true);

    this.getInfluencerChannels({
      influencer_uuid: this.user.influencer.uuid
    }).then(data => {
      this.influencerChannels = data;
      this.setChannels(data);
      this.setPageLoading(false);
    });
  }
};
</script>

<style scoped>
.ch-page {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 24px 20px 40px;
}
.ch-header { margin-bottom: 20px; }
.ch-title { font-size: 22px; font-weight: 650; color: var(--ink); margin: 0 0 2px; letter-spacing: -.02em; }
.ch-sub { font-size: 13.5px; color: var(--ink-3); margin: 0; }

.ch-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.ch-add-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 280px;
  border: 1.5px dashed var(--line, #e0e0e0);
  border-radius: var(--r-lg, 14px);
  color: var(--ink-3, #aaa);
  text-decoration: none;
  transition: border-color .15s, color .15s, background .15s;
}
.ch-add-tile:hover {
  border-color: var(--accent, #e05540);
  color: var(--accent, #e05540);
  background: var(--accent-soft, rgba(224,85,64,0.05));
}
.ch-add-tile i { font-size: 40px; }
.ch-add-tile span { font-size: 13px; font-weight: 600; }
</style>